import {
  ExFMMessageInfo,
  PostSendExFM,
  PostUploadFileToExFM,
} from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

const uploadFileEndPoint = 'send-exfm-upload';
const linkDataEndPoint = 'send-exfm';

/** ExFMのストレージへの画像アップロード */
export const postUploadFileToExFM = async (
  params: PostUploadFileToExFM,
): Promise<void> => {
  const url = getApiUrl(uploadFileEndPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(params),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

/** ExFMへのデータ連携 */
export const postSendExFM = async (
  params: PostSendExFM,
): Promise<ExFMMessageInfo> => {
  const url = getApiUrl(linkDataEndPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(params),
    contentType: 'application/json',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
